import React, { FC, PropsWithChildren } from 'react'
import { makeStyles } from 'tss-react/mui'
import withV4IndexPriority from '../../../styles/withV4IndexPriority'
import { Theme } from '@mui/material/styles'
import { Grid } from '@mui/material'

import { LMBasicV3FSMProps } from '../../../types/interface/layouts.interface'
import { FSMBreadcrumbs, Typography } from '@dg-shared'
import { StylesProps } from '../../../types/interface/styles.interface'
// Changed according to the specific design [link on task]

const useStyles = makeStyles<StylesProps>()((theme: Theme, props) =>
  withV4IndexPriority({
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: `${props.height}px`,
    },

    page: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(2),
    },

    content: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    },

    title: {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(2),
    },

    subTitle: {
      marginBottom: theme.spacing(3),
    },
  })
)

const LMBasicV3: FC<PropsWithChildren<LMBasicV3FSMProps>> = ({
  send,
  titleHeader,
  H2SubTitle,
  paragraphSubTitle,
  breadcrumbsBtnText,
  breadcrumbsStepPercentage,
  breadcrumbsBackHandler,
  children,
  customClass, //FIXME: Remove this prop when all pages will have the same positioning of elements
  breadcrumbs = false,
}) => {
  const { classes, cx } = useStyles({ height: window.innerHeight })

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.page}>
        {breadcrumbs && (
          <FSMBreadcrumbs
            send={send}
            breadcrumbsBackHandler={breadcrumbsBackHandler}
            buttonText={breadcrumbsBtnText}
            stepsPercentage={breadcrumbsStepPercentage}
          />
        )}
        {!!titleHeader && (
          <Typography type='h1' className={classes.title}>
            {titleHeader}
          </Typography>
        )}
        {!!H2SubTitle && (
          <Typography type='h2' className={classes.subTitle}>
            {H2SubTitle}
          </Typography>
        )}
        {!!paragraphSubTitle && (
          <Typography className={classes.subTitle}>{paragraphSubTitle}</Typography>
        )}
        <section className={cx(classes.content, customClass)}>{children}</section>
      </Grid>
    </Grid>
  )
}

export default LMBasicV3
